import { Component } from '@angular/core'

@Component({
  selector: 'fuel-report',
  templateUrl: './asset.component.html',
})
export class AssetReportComponent {
  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/reports/itAsset/asset.component.ts